<template>
  <div class="details">
    <div v-if="selectedElement" class="icon-container">
      <i :class="selectedElement.directory ? 'folder' : 'doc'" class="icon" />
    </div>

    <div v-if="selectedElement">
      <div v-if="isRoot" class="bold">{{ $t('g-fileExplorer:root') | capitalize }}</div>
      <div v-else><span class="bold">{{ $t('g-fileExplorer:name') | capitalize }}</span> {{ selectedElement.name }}</div>

      <div v-if="!selectedElement.directory && selectedElement.size"><span class="bold">{{ $t('g-fileExplorer:size') | capitalize }}</span> {{ selectedElement.size | octet }}</div>
      <div v-if="children.length">{{ $t('g-fileExplorer:countElement', {count:children.length}) }}</div>
    </div>

    <div v-if="selectedElement">
      <div v-if="!isRoot && selectedElement.date"><span class="bold">{{ $t('g-fileExplorer:lastUpdate') | capitalize }}</span> {{ selectedElement.date | date }}</div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash-es'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['selectedElement']),

    children () {
      return !isEmpty(this.selectedElement) ? this.selectedElement.children : []
    },

    isRoot () {
      return this.selectedElement.name === '/'
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .details {
    display: flex;
    justify-content: space-between;
    height: 85px;
    padding: 20px;
    overflow: auto;
    color: $primary;
    background-color: $gray-300;

    .icon-container {
      margin-right: 20px;
    }

    & > div:not(.icon-container) {
      flex: 1;
    }

    i.icon {
      display: inline-block;
      width: 41px;
      height: 41px;
      padding: 0;
      margin: 0;
      line-height: 0;
      vertical-align: middle;
      cursor: default;
      background-color: transparent;
      background-image: url("~@/img/file-explorer-big.png");
      background-repeat: no-repeat;
      background-attachment: scroll;
      border: 0 none;
      outline: none;

      &.folder {
        background-position: 0 0;
      }

      &.doc {
        background-position: -82px 0;
      }
    }
  }
</style>
